<template>
  <v-app app>
    <v-navigation-drawer
      v-model="show_drawer"
      :permanent="!$vuetify.breakpoint.xsOnly"
      style="box-shadow: 4px 0px 6px rgba(0, 0, 0, 0.1)"
      app
    >
      <div class="d-flex align-center">
        <img
          src="/logo.svg"
          width="60"
          height="60"
          style="margin-right: 10px"
        />
        ЛИЧНЫЙ КАБИНЕТ
      </div>
      <v-list class="pa-0">
        <v-list-item-group active-class="active-item">
          <template v-for="item in filteredMenu">
            <template v-if="item.children">
              <v-list-group
                :key="item.label"
                :value="$route.path.indexOf(item.keyword) !== -1"
                append-icon=""
                no-action
                @click.stop="onGroupClick(item)"
              >
                <template v-slot:activator>
                  <v-list-item-icon class="ml-6">
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <ns-menu-item
                  v-for="child in item.children"
                  :key="child.label"
                  :icon="child.icon"
                  :to="{ name: child.path }"
                  :label="child.label"
                  :active="$route.path.indexOf(child.keyword) !== -1"
                />
              </v-list-group>
            </template>
            <ns-menu-item
              v-else-if="!item.action"
              :key="item.label"
              :icon="item.icon"
              :to="{ name: item.path }"
              :label="item.label"
              :active="$route.path.indexOf(item.keyword) !== -1"
            />
            <ns-menu-item
              v-else
              :key="item.label + '-action'"
              :icon="item.icon"
              :to="{ name: item.path }"
              :label="item.label"
              :active="$route.path.indexOf(item.keyword) !== -1"
            />
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main style="background-color: #f0f8f6" class="mb-6">
      <v-container fluid class="ma-0 pa-0">
        <v-toolbar height="64x" flat style="z-index: 1">
          <v-app-bar-nav-icon
            v-if="$vuetify.breakpoint.xsOnly"
            @click.stop="show_drawer = !show_drawer"
          ></v-app-bar-nav-icon>
          <v-spacer></v-spacer>
          <v-card elevation="0" class="d-flex align-center">
            <v-card-text
              class="toolbar-content balance-text text-caption text-sm-subtitle-1 text-no-wrap py-1 px-2"
              v-if="canSeeBalance"
            >
              Баланс:
              <span class="balance-amount">{{
                userCompany?.balance || 0
              }}</span>
            </v-card-text>
            <v-btn
              v-if="canSeeBalance"
              small
              color="primary"
              class="ml-2"
              @click="showTopupModal = true"
            >
              Пополнить
            </v-btn>
          </v-card>
          <v-spacer></v-spacer>
          <v-card elevation="0" class="d-flex align-center">
            <v-card-text
              class="toolbar-content balance-text text-caption text-sm-subtitle-1 text-no-wrap py-1 px-2"
              v-if="userCompany?.manager_id"
            >
              Менеджер: {{ this.companyManager }}
            </v-card-text>
          </v-card>
          <v-spacer></v-spacer>
          <v-card elevation="0" class="d-flex align-center">
            <v-card-text
              class="toolbar-content balance-text text-caption text-sm-subtitle-1 text-no-wrap py-1 px-2"
            >
              {{ userCompany?.name || "" }}
            </v-card-text>
          </v-card>
          <v-spacer></v-spacer>
          <v-toolbar-items class="d-flex">
            <v-expansion-panels hover flat accordion>
              <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" style="min-height: 100%">
                  <div class="d-flex justify-center align-center pa-0">
                    <v-icon color="primary">mdi-account-circle</v-icon>
                    <span
                      class="user-email text-truncate"
                      style="min-width: 40px"
                      >{{ user.email }}</span
                    >
                  </div>
                  <template v-slot:actions>
                    <v-icon color="primary"> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  id="expansion-panel-content-1"
                  style="position: absolute; right: 0; top: 100%; z-index: 10"
                >
                  <div class="d-flex flex-column">
                    <v-btn
                      depressed
                      color="white"
                      @click="showChangePasswordModal = true"
                      class="pa-0 flex-grow-1"
                    >
                      <div>
                        <v-icon color="primary">mdi-lock-reset</v-icon>
                        Сменить пароль
                      </div>
                    </v-btn>
                    <v-divider></v-divider>
                    <v-btn
                      depressed
                      color="white"
                      @click="doLogout"
                      class="pa-0 flex-grow-1"
                    >
                      <div>
                        <v-icon color="primary">mdi-exit-run</v-icon>
                        Выход
                      </div>
                    </v-btn>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-toolbar-items>
        </v-toolbar>
      </v-container>
      <v-container class="px-2 px-sm-10" fluid app>
        <slot />
      </v-container>
    </v-main>
    <v-dialog v-model="showTopupModal" max-width="500">
      <BalanceTopupModal @cancel="showTopupModal = false" />
    </v-dialog>
    <v-dialog v-model="showChangePasswordModal" max-width="500">
      <v-card>
        <v-card-title>Смена пароля</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="changePassword">
            <v-text-field
              v-model="currentPassword"
              label="Текущий пароль"
              :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showCurrentPassword ? 'text' : 'password'"
              @click:append="showCurrentPassword = !showCurrentPassword"
              required
            ></v-text-field>
            <v-text-field
              v-model="newPassword"
              label="Новый пароль"
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showNewPassword ? 'text' : 'password'"
              @click:append="showNewPassword = !showNewPassword"
              required
            ></v-text-field>
            <v-text-field
              v-model="newPasswordConfirm"
              label="Повторить новый пароль"
              :append-icon="showNewPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showNewPasswordConfirm ? 'text' : 'password'"
              @click:append="showNewPasswordConfirm = !showNewPasswordConfirm"
              required
            ></v-text-field>
            <div v-if="changePasswordMessage">{{ changePasswordMessage }}</div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showChangePasswordModal = false">Отмена</v-btn>
          <v-btn color="primary" @click="changePassword">Сменить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="3000" top color="success">
      {{ snackbarText }}
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NsMenuItem from "@/components/NsMenuItem";
import BalanceTopupModal from "@/components/BalanceTopupModal.vue";
import NSApi from "@/api/NSApi";

export default {
  name: "CustomerLayout",
  components: { NsMenuItem, BalanceTopupModal },
  data() {
    return {
      showChangePasswordModal: false,
      currentPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
      changePasswordMessage: "",
      showCurrentPassword: false,
      showNewPassword: false,
      showNewPasswordConfirm: false,
      companyManager: "",
      show_drawer: false,
      showTopupModal: false,
      snackbar: false,
      snackbarText: "",
      menu: [
        {
          path: "company-users",
          label: "Сотрудники",
          icon: "mdi-account-circle",
          keyword: "users",
        },
        {
          path: "company-patients",
          label: "Пациенты",
          icon: "mdi-account-plus",
          keyword: "patients",
        },
        {
          label: "Материалы",
          icon: "mdi-human-male-child",
          keyword: "parents",
          defaultChild: "company-parents-adults",
          children: [
            {
              path: "company-parents-adults",
              label: "Для взрослых",
              icon: "mdi-account",
              keyword: "adults",
            },
            {
              path: "company-parents-children",
              label: "Для детей",
              icon: "mdi-human-male-child",
              keyword: "children",
            },
          ],
        },
        {
          path: "company-reports",
          label: "Отчеты",
          icon: "mdi-chart-arc",
          keyword: "reports",
        },
        {
          path: "company-news",
          label: "Новости",
          icon: "mdi-newspaper",
          keyword: "news",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters("companies", ["companies"]),

    // Фича-флаг из user_feature: строки нет — доступ есть (дефолт),
    // enabled=false — баланс компании скрыт от этого пользователя.
    canSeeBalance() {
      return this.user.features?.BALANCE_VISION !== false;
    },

    filteredMenu() {
      // Условие для фильтрации меню
      if (this.user.role === "company-user") {
        return this.menu.filter((item) => item.keyword !== "reports");
      }
      return this.menu;
    },

    userCompany() {
      return this.companies.find(
        (company) => company.id === this.user.company_id
      );
    },
  },
  methods: {
    ...mapActions(["doLogout"]),
    ...mapActions("companies", ["request_companies"]),
    onGroupClick(item) {
      if (!(item.children && item.defaultChild)) return;
      if (this.$route.name !== item.defaultChild) {
        this.$router.push({ name: item.defaultChild });
      }
    },
    async changePassword() {
      this.changePasswordMessage = "";
      if (this.newPassword !== this.newPasswordConfirm) {
        this.changePasswordMessage = "Пароли не совпадают";
        return;
      }

      const passwordRegex =
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
      if (!passwordRegex.test(this.newPassword)) {
        this.changePasswordMessage =
          "Новый пароль не соответствует требованиям. Пароль должен содержать минимум 8 символов, буквы, цифры и специальные символы.";
        return;
      }

      try {
        await NSApi.instance.changePassword(
          this.currentPassword,
          this.newPassword
        );
        this.showChangePasswordModal = false;
        this.currentPassword = "";
        this.newPassword = "";
        this.newPasswordConfirm = "";
        this.snackbarText = "Пароль успешно изменен";
        this.snackbar = true;
      } catch (error) {
        this.changePasswordMessage =
          error.response?.data?.message || "Произошла ошибка";
      }
    },
  },
  async mounted() {
    await this.request_companies();
    if (this.userCompany.Manager)
      this.companyManager =
        this.userCompany.Manager.first_name +
        " " +
        this.userCompany.Manager.last_name;
  },
};
</script>

<style scoped lang="scss">
.toolbar-content {
  background-color: #f0f8f6;
  color: #d86568 !important;
}
.balance-text {
  color: #000000 !important;
}
.balance-amount {
  font-weight: bold;
}
.user-email {
  max-width: 200px;
}

#expansion-panel-content-1::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

@import "~vuetify/src/styles/styles.sass";

@media #{map-get($display-breakpoints, 'xs-only')} {
  .user-email {
    max-width: 50px;
  }
}

.v-list-item .v-list-item__icon .v-icon {
  color: #23919e !important;
}
</style>
